import { AnimatedItem } from '@/components/features/casino/rush/WinningBroadcast/styles';
import { PrizeType, RewardRecord } from '../types';
import { Typography } from '@mui/material';
import {
  IsMoneyAward,
  IsTimeAward,
  PRIZEMaps,
} from '@/components/features/casino/rush/constances';
import MoneyWithCurrencyIcon from '@/components/biz/MoneyWithCurrencyIcon';
import { useTranslation } from 'next-i18next';

interface MemberItemProp {
  opacity: number;
  item: RewardRecord;
  style?: Record<string, any>;
}

export default function MemberItem({
  opacity = 1,
  item,
  style = {},
}: MemberItemProp) {
  const { t } = useTranslation();

  const PrefixIcon = (rewardType: PrizeType) => {
    if (IsTimeAward(rewardType)) {
      return <Typography sx={{ mr: '4px' }}>{'✨'}</Typography>;
    } else if (IsMoneyAward(rewardType)) {
      return <Typography sx={{ mr: '4px' }}>{'🎉'}</Typography>;
    } else {
      return null;
    }
  };
  return (
    <AnimatedItem opacity={opacity} key={`${item.createdTime}`} style={style}>
      {PrefixIcon(item.rewardType)}
      <Typography>
        {item.userName ? item.userName : 'hidden'}
        {t(' won')}
      </Typography>
      <Typography
        sx={{
          display: 'flex',
          alignItems: 'center',
          ml: 0.5,
          color: (theme) => theme.palette.primary.main,
        }}
      >
        <MoneyWithCurrencyIcon value={item.payout} currency={item.currency} />
      </Typography>
      <Typography>
        ，{t(' mined ')}
        <Typography
          component={'span'}
          sx={{
            color: (theme) => theme.palette.primary.main,
          }}
        >
          {Math.abs(Number(item?.point) || 0)}
        </Typography>
        {' points'}
      </Typography>
    </AnimatedItem>
  );
}
